import React, { useState, useEffect, useCallback } from "react";

import PageHeader from "@/components/shared/PageHeader";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

// import UserManagementTable from "@/components/shared/UserManagementTable";
// import VehicleManagementTable from "@/components/shared/VehicleManagementTable";
// import AddVehicleModal from "@/components/shared/AddVehicleModal";
import { Truck, User } from 'lucide-react';
import UserManagement from "./superadmin/UserManagement";
import VehicleManagement from "@/components/shared/VehicleManagement";
import api from "@/lib/api";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useAuth } from "@/lib/auth";


const ServiceProviderDetails = () => {
  const { organizationId: organizationIdParam, id } = useParams();
  const { user, orgId: sessionOrgId } = useAuth();
  const organizationId = organizationIdParam || id || sessionOrgId || user?.org_id || null;
  const navigate = useNavigate();
  const [loadingOrg, setLoadingOrg] = useState(Boolean(organizationId));
  const [totalUsers, setTotalUsers] = useState(0);
  const [totalVehicles, setTotalVehicles] = useState(0);

  useEffect(() => {
    if (!organizationId) return setLoadingOrg(false);

    let mounted = true;
    (async () => {
      try {
        await api.get(`/organizations/${organizationId}`);
        if (mounted) {
          setLoadingOrg(false);
        }
      } catch (err) {
        const status = err?.response?.status;
        if (status === 404) {
          navigate("/404");
        } else {
          // If other error, stop loading and allow children to handle empty state
          if (mounted) setLoadingOrg(false);
        }
      }
    })();

    return () => {
      mounted = false;
    };
  }, [organizationId, navigate]);

  const fetchCounts = useCallback(async () => {
    const userParams = { page: 1, page_size: 1 };
    const vehicleParams = { page: 1, page_size: 1 };
    if (organizationId) {
      userParams.organization_id = organizationId;
      vehicleParams.organization_id = organizationId;
    } else {
      userParams.org_type = "CUSTOMER";
      vehicleParams.vehicle_category = "USER_VEHICLE";
    }

    try {
      const [usersResp, vehiclesResp] = await Promise.all([
        api.get("/users", { params: userParams }),
        api.get("/vehicles", { params: vehicleParams }),
      ]);

      const uTotal = usersResp?.data?.meta?.total ?? (Array.isArray(usersResp?.data?.data) ? usersResp.data.data.length : 0);
      const vTotal = vehiclesResp?.data?.meta?.total ?? (Array.isArray(vehiclesResp?.data?.data) ? vehiclesResp.data.data.length : 0);
      setTotalUsers(uTotal);
      setTotalVehicles(vTotal);
    } catch (err) {
      setTotalUsers(0);
      setTotalVehicles(0);
    }
  }, [organizationId]);

  useEffect(() => {
    let mounted = true;

    const run = async () => {
      try {
        await fetchCounts();
      } finally {
        if (!mounted) return;
      }
    };

    if (organizationId && loadingOrg) return;
    run();

    return () => {
      mounted = false;
    };
  }, [organizationId, loadingOrg, fetchCounts]);

  return (
    <>
    <div className="space-y-6">
            <PageHeader
                title="Service Provider Details"
                subtitle="View and manage the details of the service provider."
              />
              <div className="grid grid-cols-2 gap-4 lg:grid-cols-2">
                 <div

      className="flex items-center justify-between rounded-xl border border-slate-100 bg-white p-5 shadow-[0_2px_10px_-3px_rgba(15,23,42,0.05)] transition-all hover:-translate-y-[1px] hover:shadow-[0_8px_30px_rgb(0,0,0,0.05)]"
    >
      <div className="space-y-1">
        <p className="text-[11px] font-semibold uppercase tracking-widest text-slate-500">
            Total Users
        </p>
        <p className="font-display text-3xl font-bold tabular-nums text-slate-900">{totalUsers}</p>
        
      </div>
     
        <div
          className="flex h-12 w-12 items-center justify-center rounded-xl bg-slate-100 "
        >
          <User size={20} strokeWidth={1.75} />
        </div>
    
                </div>
                <div

      className="flex items-center justify-between rounded-xl border border-slate-100 bg-white p-5 shadow-[0_2px_10px_-3px_rgba(15,23,42,0.05)] transition-all hover:-translate-y-[1px] hover:shadow-[0_8px_30px_rgb(0,0,0,0.05)]"
    >
      <div className="space-y-1">
        <p className="text-[11px] font-semibold uppercase tracking-widest text-slate-500">
            Total Vehicles  
        </p>
        <p className="font-display text-3xl font-bold tabular-nums text-slate-900">{totalVehicles}</p>
        
      </div>
     
        <div
          className="flex h-12 w-12 items-center justify-center rounded-xl bg-slate-100 "
        >
          <Truck size={20} strokeWidth={1.75} />
        </div>
    
                </div>
                
              </div>


            <div className="space-y-6 ">
      <Tabs defaultValue="users">
        <div className="flex justify-between items-center">

          <TabsList>

            <TabsTrigger value="users">
              User Management
            </TabsTrigger>

            <TabsTrigger value="vehicles">
              Vehicle Management
            </TabsTrigger>

          </TabsList>

        </div>

        <div className="border border-slate-100 rounded-xl bg-white shadow-[0_2px_10px_-3px_rgba(15,23,42,0.05)] transition-all hover:-translate-y-[1px] hover:shadow-[0_8px_30px_rgb(0,0,0,0.05)] mt-5 p-5 new-fix-hei">

        <TabsContent value="users">
          <div >
            <UserManagement orgId={organizationId} loadingOrg={loadingOrg} />
          </div>

        </TabsContent>

        <TabsContent value="vehicles">
          <div>
            <VehicleManagement
              orgId={organizationId}
              loadingOrg={loadingOrg}
            />
          </div>

        </TabsContent>

        </div>
      </Tabs>

 


            </div>

    </div>
    </>
  )
}

export default ServiceProviderDetails